import { CampaignType } from 'cio/models/campaign';

export const DEFAULT_FORMAT = 'YYYY-MM-DD';
export const NEWSLETTERS = 'newsletters';

export const TYPE_ICONS = {
  newsletter: 'newsletter',
  [CampaignType.APITriggered]: 'api-triggered',
};
